// The References of every program (GET /api/references): numbered per program, each paper tagged with what it is the
// source for (qdtransport/references.py TAG_LABELS: skfitter-fit, skfitter-berry, qtetris-level1, ...).
import { useQuery } from "@tanstack/react-query";
import { get } from "./api";
import type { Reference } from "./transport";

export type ProgramKey = "transport" | "skfitter" | "wannier" | "qtetris";
export interface ReferenceSection { key: ProgramKey; program: string; references: Reference[] }

export function useReferences() {
  return useQuery({ queryKey: ["references"], queryFn: () => get<ReferenceSection[]>("/references"), staleTime: 60 * 60 * 1000 });
}

/** The program's papers carrying ``tag`` (in their numbered order); [] while loading or when there are none. */
export function tagged(sections: ReferenceSection[] | undefined, program: ProgramKey, tag: string): Reference[] {
  return sections?.find((s) => s.key === program)?.references.filter((r) => r.tags.includes(tag)) ?? [];
}

/** Hook form of {@link tagged}. */
export function useTagged(program: ProgramKey, tag: string): Reference[] {
  return tagged(useReferences().data, program, tag);
}
